import React from "react";
import { AutoAwesomeMosaic } from "@mui/icons-material";
import { AdminIconBarItem } from "../icon-bar/AdminIconBarItem";
import { useScrollytellTranslation } from "../Admin/scrollytellContext";
import { SectionTemplates } from "../helpers/enums";

export const TemplatePresetButton = ({ templateId, onClick, active = false }) => {
  const t = useScrollytellTranslation();

  const isSupported =
    templateId === SectionTemplates.TITLE_SECTION ||
    templateId === SectionTemplates.BODYTEXT_SECTION ||
    templateId === 1 ||
    templateId === 2;

  if (!isSupported) {
    return null;
  }

  return (
    <AdminIconBarItem
      Icon={AutoAwesomeMosaic}
      onClick={() => onClick("presetMenu")}
      tooltip={t(
        "editSectionPanel.presetTooltip",
        "Oppsett og forhåndsinnstillinger"
      )}
      tooltipPosition="top"
      classname={active ? "active-preset-menu" : ""}
      data-testid="template-preset-button"
    />
  );
};
